import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";
import { createHead } from '@unhead/vue'
import { UnheadPlugin } from '@unhead/vue/vue2'

Vue.config.productionTip = false;

window.addEventListener('unhandledrejection', result => store.commit("addError", result.reason));

Vue.config.errorHandler = function (err) {
  store.commit("addError", err)
}

const signOutIfExpired = () => {
  store.commit('signOutIfExpired');
}

setInterval(() => {
  signOutIfExpired();
}, 60*1000);

signOutIfExpired();
store.commit('loadTags');
store.dispatch('showPaymentNotice');

const head = createHead()
Vue.use(UnheadPlugin)

new Vue({
  router,
  store,
  render: h => h(App),
  unhead: head
}).$mount("#app");
